import join from './join'

const apellidos = ({ primerApellido, segundoApellido }) => join([primerApellido, segundoApellido])

export default apellidos
